import React, { Fragment, useEffect, useReducer, useState } from "react"; 
import { Button, Modal, Tab, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import PageTitle from "../../layouts/PageTitle";
import { AddUpdate, getPostData } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import user from './../../../images/task/user.jpg';
import { useDispatch, useSelector } from "react-redux";
import { get_BankDetailsData, get_AstrologerSingleData, get_DregeeDiploma, get_Qualification, get_SkillData, get_LanguagesData, get_CategoryData } from "../../../store/actions/CommanAction";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import { getShowingDateText, getShowingMonthDateYear } from "../Utility/Utility";
import BankDetails from "./BankDetails";
import About from "./About";
import profile_icon from "../../../icons/flaticon/profile_icon.png";
import { baseURLS } from "../../../services/AxiosInstance";



const initialState = false;

const reducer = (state, action) => {
    switch (action.type) {
        case 'sendMessage':
            return { ...state, sendMessage: !state.sendMessage }
        case 'postModal':
            return { ...state, post: !state.post }
        case 'linkModal':
            return { ...state, link: !state.link }
        case 'cameraModal':
            return { ...state, camera: !state.camera }
        case 'aadharModal':
            return { ...state, camera: !state.aadhar }
        case 'replyModal':
            return { ...state, reply: !state.reply }
        default:
            return state
    }
}

const AstrologerAdd = ({ onClose, refereshfunction }) => {
    const dispatch = useDispatch()
    const SkillsData = useSelector((state) => state.feedBackReducer.SkillsData);
    const LanguagesData = useSelector((state) => state.feedBackReducer.LanguagesData);
    const AstrologerSingleData = useSelector((state) => state.feedBackReducer.AstrologerSingleData);
    const selectedAstroId = useSelector((state) => state.feedBackReducer.selectedAstroId);
    const QualificationDrpData = useSelector((state) => state.feedBackReducer.QualificationDrpData);
    const DregeeDiplomaDrpData = useSelector((state) => state.feedBackReducer.DregeeDiplomaDrpData);
    const CategroyData = useSelector((state) => state.feedBackReducer.CategoryData);
   
    const [file, setFile] = React.useState(null)
    const [DOB, setDOB] = useState()
    //--------------------AstrologerDetails----------------
    const [EditValue, setEditValue] = useState()
    const [aboutusdata, setaboutusdata] = useState()
    const [Value, SetValue] = useState({
        'FirstName': '', 'LastName': '', 'DisplayName': '', 'EmailID': '', 'RegMobileNo': '', 'PrimaryMobileNo': '',
        'SecondaryMobileNo': '', 'DOB': '', 'TOB': '', 'POB': '', 'City': '', 'CurrentAddress': '',
        'Faith': '', 'Languages': '', 'ExperiencedYears': '', 'AstrologerID': '', 'IsHomePage': '',
        'AadharNo': '', 'PANCardNo': '', 'Maritalstatus': '', 'Gender': '', 'CreatedByUser': 1, 'Status': '',
    })

    const [displayError, setDisplayError] = useState("");
    const [checkingDisplay, setCheckingDisplay] = useState(false);

    const handleAddFormSubmit = async (e) => {
        e.preventDefault();
        let error = false;
        let errorMsg = '';

        let firstname = Value.FirstName.trim();
        let RegMobileNo = Value.RegMobileNo?.trim();
        let Gender = Value.Gender?.trim();
        let DOB = Value.DOB?.trim();
        let City = Value.City?.trim();
        let CurrentAddress = Value?.CurrentAddress?.trim();
        let AadharNo = Value.AadharNo?.trim();
        let PANCardNo = Value.PANCardNo?.trim();
        let Maritalstatus = Value.Maritalstatus?.trim();
        let POB = Value.POB?.trim();
        let LastName = Value.LastName?.trim();
        let DisplayName = Value.DisplayName?.trim();

        if (!firstname) {
            error = true;
            errorMsg = 'Please fill FirstName.';
        }


        if (!RegMobileNo) {
            error = true;
            errorMsg = 'Please fill RegMobileNo.';
        }


        if (!POB) {
            error = true;
            errorMsg = "Please fill Place of Birth";
        }

        if (!CurrentAddress) {
            error = true;
            errorMsg = "Please fill Current Address";
        }
        if (!City) {
            error = true;
            errorMsg = "Please fill City";
        }


        if (!AadharNo) {
            error = true;
            errorMsg = "Please fill AadharNo";
        }
        if (!Maritalstatus && Maritalstatus === "") {
            error = true;
            errorMsg = "Please fill Merital Status";
        }
        if (!Gender) {
            error = true;
            errorMsg = "please fill Gender";
        }

        if (displayError) {
  error = true;
  errorMsg = "Display Name already exists";
}


        if (Value.EmailID !== "") {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(Value.EmailID)) {
                error = true;
                errorMsg = 'Please enter a valid Email ID.';
            }
        }
        if (!error) {
          
            await AddUpdate('Astrologer/InsertAstrologerDetails', Value);
            swal('Good job!', 'Successfully Added', "success");
        } else {
            swal('Oops', errorMsg, "error");
        }
    }
    const [showInput, setShowInput] = useState(true);

    const handleTimeChange = (e) => {
        const selectedTime = e.target.value;
        const currentTime = new Date(); 
       
        const currentHours = String(currentTime.getHours()).padStart(2, '0');
        const currentMinutes = String(currentTime.getMinutes()).padStart(2, '0');
        const currentTimeString = `${currentHours}:${currentMinutes}`;

       
        if (selectedTime > currentTimeString) {
            setShowInput(false); 
        } else {
            setShowInput(true); 
            SetValue({ ...Value, TOB: selectedTime }); 
        }
    };

   

    const handleAddFormUpdate = async (e) => {

        e.preventDefault();
        let error = false;
        let errorMsg = '';

        let firstname = Value.FirstName.trim();
        let RegMobileNo = Value.RegMobileNo?.trim();
        let Gender = Value.Gender?.trim();
        let DOB = Value.DOB?.trim();
        let City = Value.City?.trim();
        let CurrentAddress = Value?.CurrentAddress?.trim();
        let AadharNo = Value.AadharNo?.trim();
        let PANCardNo = Value.PANCardNo?.trim();
        let Maritalstatus = Value.Maritalstatus?.trim();
        let POB = Value.POB?.trim();
        let LastName = Value.LastName?.trim();
        let DisplayName = Value.DisplayName?.trim();

        if (!firstname) {
            error = true;
            errorMsg = 'Please fill FirstName.';
        }

        if (!DisplayName) {
            error = true;
            errorMsg = 'Please fill Display Name.';
        }

        if (!RegMobileNo) {
            error = true;
            errorMsg = 'Please fill RegMobileNo.';
        }


        if (!POB) {
            error = true;
            errorMsg = "Please fill Place of Birth";
        }

        if (!CurrentAddress) {
            error = true;
            errorMsg = "Please fill Current Address";
        }
        if (!City) {
            error = true;
            errorMsg = "Please fill City";
        }


        if (!AadharNo) {
            error = true;
            errorMsg = "Please fill AadharNo";
        }
        if (!Maritalstatus && Maritalstatus === "") {
            error = true;
            errorMsg = "Please fill Merital Status";
        }
        if (!Gender) {
            error = true;
            errorMsg = "please fill Gender";
        }



        if (Value.EmailID !== "") {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(Value.EmailID)) {
                error = true;
                errorMsg = 'Please enter a valid Email ID.';
            }
        }
        if (!error) {

            await AddUpdate('Astrologer/Update_Astrologer', Value);
            refereshfunction()
            onClose()

            swal('Good job!', 'Successfully Update', "success");
        } else {
            swal('Oops', errorMsg, "error");
        }
    }

    useEffect(() => {
        dispatch(get_AstrologerSingleData(selectedAstroId))
    }, [selectedAstroId])


    useEffect(() => {
        setEditValue(AstrologerSingleData)
    }, [AstrologerSingleData])

    useEffect(() => {
        if (EditValue && EditValue.length > 0) {
            SetValue({
                ...Value,
                AstrologerID: selectedAstroId,
                'FirstName': EditValue[0]?.FirstName, 'EmailID': EditValue[0]?.EmailID,
                'LastName': EditValue[0]?.LastName, 'Status': EditValue[0]?.Status,
                'DisplayName': EditValue[0]?.DisplayName,
                'RegMobileNo': EditValue[0]?.RegMobileNo,
                'PrimaryMobileNo': EditValue[0]?.PrimaryMobileNo,
                'SecondaryMobileNo': EditValue[0]?.SecondaryMobileNo,
                'DOB': EditValue[0].DOB ? getShowingDateText(EditValue[0].DOB) : '',
                'TOB': EditValue[0]?.TOB, 'POB': EditValue[0]?.POB,
                'City': EditValue[0]?.City, 'PINCode': EditValue[0]?.PINCode,
                'Faith': EditValue[0]?.Faith, 'CurrentAddress': EditValue[0]?.CurrentAddress,
                'AadharNo': EditValue[0]?.AadharNo,
                'PANCardNo': EditValue[0]?.PANCardNo,
                'EMPID': EditValue[0]?.EMPID, 'IsHomePage': EditValue[0]?.IsHomePage,
                'AvatarUrl': EditValue[0]?.AvatarUrl, 'DisplayName': EditValue[0]?.DisplayName,
                'Maritalstatus': EditValue[0]?.Maritalstatus,
                'Gender': EditValue[0]?.Gender,
            });
        }
    }, [EditValue]);

    
    useEffect(() => {
        if (!selectedAstroId) {
            SetValue({
                'FirstName': '', 'LastName': '', 'DisplayName': '', 'EmailID': '', 'RegMobileNo': '', 'PrimaryMobileNo': '',
                'SecondaryMobileNo': '', 'DOB': '', 'TOB': '', 'POB': '', 'City': '', 'CurrentAddress': '',
                'Faith': '', 'Languages': '', 'ExperiencedYears': '', 'AstrologerID': '', 'IsHomePage': '',
                'AadharNo': '', 'PANCardNo': '', 'Maritalstatus': '', 'Gender': '', 'CreatedByUser': 1, 'Status': '',
            });
            SetAboutValue({
                'ExperiencedYears': '', 'Languages': '', 'Aboutme': '', 'skills': '', "CategoryID": "", 'AstrologerID': '', 'ModifiedByUser': 1, 'IsActive': '1'
            });
            SetQualificationValue({
                'HighestQualification': '', 'DregeeDiploma': '', 'CollegeUniversity': '', 'WhereLearnAstrology': '', 'AstrologerID': '', 'ModifiedByUser': '1'
            });
            setFormDataAt({
                AstrologerID: '',
                ModifiedByUser: '',
                files: {
                    frontImg: null,
                    backImg: null,
                }
            });
            setEditValue(undefined);
        }
    }, [selectedAstroId]);

    
    useEffect(() => {
        if (selectedAstroId) {
            dispatch(get_AstrologerSingleData(selectedAstroId));
        }
    }, [selectedAstroId]);


    const HandleChange = (e) => {
        if (e.target.name === 'IsHomePage') {
            SetValue({
                ...Value,
                [e.target.name]: e.target.checked,
            });
        }
        else {
            SetValue({
                ...Value,
                [e.target.name]: e.target.value,
            });
        }
    }
    const Reset = () => {
        SetValue({
            ...Value,
            'FirstName': '', 'LastName': '', 'DisplayName': '', 'EmailID': '', 'IsHomePage': '', 'RegMobileNo': '', 'PrimaryMobileNo': '',
            'SecondaryMobileNo': '', 'DOB': '', 'TOB': '', 'POB': '', 'City': '', 'CurrentAddress': '',
            'Faith': '', 'Languages': '', 'ExperiencedYears': '',
            'AadharNo': '', 'PANCardNo': '', 'Maritalstatus': '', 'Gender': '',
        })
    }

    const handleUpdatePhoto = async () => {
       
        const formData = new FormData();
        const dataObject = {
            AstrologerID: selectedAstroId,
            ModifiedByUser: '1',
        };
        formData.append('Data', JSON.stringify(dataObject));
        formData.append('File', file);
        try {
            await AddUpdate('Astrologer/UpdateAstrologerPhoto', formData);
            refereshfunction()

            swal('Good job!', 'Successfully Added', 'success');
        }

        finally {
            // setFile(null);
        }
    };

    const fileHandler = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFile(file);
            // setBankvalue(prevState => ({
            SetValue(prevState => ({
                ...prevState,
                Attachmenturl: file.name
            }));
        }
    };

    //-----------------------Qualification-------------------------------

    // const [AstrologerID, setAstrologerID] = useState('')
    const [QualificationValue, SetQualificationValue] = useState({
        'HighestQualification': '', 'DregeeDiploma': '', 'CollegeUniversity': '', 'WhereLearnAstrology': '', 'AstrologerID': '',
        'AstrologerID': '', 'ModifiedByUser': '1'
    })

    useEffect(() => {
        dispatch(get_Qualification())
        dispatch(get_DregeeDiploma())
    }, [])

    useEffect(() => {
        setAstrologerID(selectedAstroId);
        dispatch(get_AstrologerSingleData(selectedAstroId))
    }, [selectedAstroId])

    useEffect(() => {
        SetQualificationValue(AstrologerSingleData)
    }, [AstrologerSingleData])




    useEffect(() => {
        if (
            AstrologerSingleData?.length > 0 &&
            QualificationDrpData?.length > 0 &&
            DregeeDiplomaDrpData?.length > 0
        ) {
            const data = AstrologerSingleData[0];

            SetQualificationValue({
                HighestQualification: data?.HighestQualification?.toString() || "",
                DregeeDiploma: data?.DregeeDiploma?.toString() || "",
                CollegeUniversity: data?.CollegeUniversity || "",
                WhereLearnAstrology: data?.WhereLearnAstrology || "",
                ModifiedByUser: 1,
                AstrologerID: data?.ID,
            });
        }
    }, [AstrologerSingleData, QualificationDrpData, DregeeDiplomaDrpData]);


    const ChangeDropDown = (selectedOption, field) => {
        SetQualificationValue((prev) => ({
            ...prev,
            [field]: selectedOption ? selectedOption.value : "",
        }));
    };


    useEffect(() => {
        if (AstrologerSingleData && AstrologerSingleData.length > 0) {
            SetQualificationValue({
                ...QualificationValue,
                'AstrologerID': AstrologerID, 'HighestQualification': AstrologerSingleData[0]?.HighestQualification || '', 'DregeeDiploma': AstrologerSingleData[0]?.DregeeDiploma || '',
                'CollegeUniversity': AstrologerSingleData[0]?.CollegeUniversity || '', 'WhereLearnAstrology': AstrologerSingleData[0]?.WhereLearnAstrology || ''
            });
        }
    }, [AstrologerSingleData]);


    const UpdateQualification = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';
        // Validation checks
        if (QualificationValue.HighestQualification === "") {
            error = true;
            errorMsg = 'Please fill HighestQualification.';
        } else if (QualificationValue.DregeeDiploma === "") {
            error = true;
            errorMsg = 'Please fill DregeeDiploma.';
        } else if (!QualificationValue.CollegeUniversity || QualificationValue.CollegeUniversity.trim() === "") {
            error = true;
            errorMsg = 'Please fill CollegeUniversity.';
        }

        if (!error) {
            await AddUpdate('Astrologer/UpdateAstrologerQualification', QualificationValue);
            refereshfunction()
            onClose()
            swal('Good job!', 'Successfully Updated', "success");
        } else {
            swal('Oops', errorMsg, "error");
        }
    };

    const HandleChangeQualification = (e) => {
        SetQualificationValue({
            ...QualificationValue,
            [e.target.name]: e.target.value,
        });
    };


    //--------------------------------Attichement--------------------------------

    const [formDataAt, setFormDataAt] = useState({
        AstrologerID: selectedAstroId,
        ModifiedByUser: '',
        files: {
            frontImg: null,
            backImg: null,
        }
    });

    useEffect(() => {
        setFormDataAt(AstrologerSingleData)
    }, [AstrologerSingleData])

    useEffect(() => {
        if (formDataAt?.length > 0) {
            setFormDataAt({
                ...formDataAt,
                'ModifiedByUser': 1,
                'AstrologerID': selectedAstroId,
                'Aadhar_back_img': formDataAt[0]?.Aadhar_back_img,
                'Aadhar_front_img': formDataAt[0]?.Aadhar_front_img,
            })
        }
    }, [formDataAt])

    useEffect(() => {
        if (formDataAt?.length > 0) {
            setFormDataAt({
                ...formDataAt[0],
                ModifiedByUser: 1,
                AstrologerID: selectedAstroId,
                files: {
                    Aadhar_back_img: formDataAt[0]?.Aadhar_back_img,
                    Aadhar_front_img: formDataAt[0]?.Aadhar_front_img,
                }
            });
        }
    }, [formDataAt]);

    const handleChangeAttichement = (e) => {
        const { name, value, files } = e.target;
        if (files && files.length > 0) {
            setFormDataAt((prevState) => ({
                ...prevState,
                files: {
                    ...prevState.files,
                    [name]: files[0]
                }
            }));
        } else {
            setFormDataAt((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const updateAttachment = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        const { files, AstrologerID } = formDataAt;
        const dataObject = {
            AstrologerID,
        };
        formData.append('Data', JSON.stringify(dataObject));
        if (files.frontImg) {
            formData.append('File', files.frontImg);
        }
        if (files.backImg) {
            formData.append('File', files.backImg);
        }
        await AddUpdate('Astrologer/UpdateAstrologerAadhar', formData);
        refereshfunction()
        onClose()
        swal('Good job!', 'Successfully Update', 'success');
        dispatch(get_BankDetailsData(selectedAstroId));
        setFormDataAt({
            AstrologerID: selectedAstroId, ModifiedByUser: '1',
            files: { frontImg: null, backImg: null, }
        });
    };


    const handleChange = (e) => {
        if (e.target.name === 'AadharNo' || e.target.name === 'PINCode' || e.target.name === 'RegMobileNo') {
            const ele = e.target.value.replace(/[^0-9.]/g, "")
            if (ele.includes('.')) {
                if (ele.length === 16) {
                    SetValue({ ...Value, [e.target.name]: ele });

                } else {
                    if (ele.substr(ele.indexOf('.') + 1).slice(0, 2)) {
                        const checkDot = ele.substr(ele.indexOf('.') + 1).slice(0, 2).match(/\./g)
                        if (!checkDot) {
                            SetValue({ ...Value, [e.target.name]: ele.substring(0, ele.indexOf(".")) + '.' + ele.substr(ele.indexOf('.') + 1).slice(0, 2) });

                            return;
                        } else {
                            return;
                        }
                    } else {
                        SetValue({ ...Value, [e.target.name]: ele })

                    }
                }
            } else {
                SetValue({
                    ...Value, [e.target.name]: ele
                });

            }
        }
        else {
            SetValue({
                ...Value, [e.target.name]: e.target.value
            })
        }
    }

    //-----------------------About Me-------------------------------
    const [IsActive, setIsActive] = useState(true);
    const [AstrologerID, setAstrologerID] = useState('')   // categoyid
    const [AboutValue, SetAboutValue] = useState({
        'ExperiencedYears': '', 'Languages': '', 'Aboutme': '', 'skills': '', "CategoryID": "", 'AstrologerID': AstrologerID, 'ModifiedByUser': 1, 'IsActive': '1'
    })

                                                         

    const HandleChangeAbout = (e) => {
        const { name, value } = e.target;
        if (name === "ExperiencedYears") {
            if (!/^\d*\.?\d*$/.test(value)) {
                return;
            }
        }
        const Aboutvalue = { ...AboutValue, [name]: value };
        SetAboutValue(Aboutvalue);

        if (name === "Aboutme") {
            setaboutusdata(value);

        }
    }

    useEffect(() => {
        SetAboutValue(AstrologerSingleData)
    }, [AstrologerSingleData])


    useEffect(() => {
        setAstrologerID(selectedAstroId);
        // dispatch(get_SkillData(selectedAstroId));
    }, [selectedAstroId])

    useEffect(() => {
        dispatch(get_SkillData(IsActive));
        dispatch(get_LanguagesData(IsActive));
        dispatch(get_CategoryData(IsActive));
        setIsActive(IsActive)
    }, [IsActive])


    

    useEffect(() => {
        if (AboutValue?.length > 0) {
         
            SetAboutValue({
                ...AboutValue,
                ModifiedByUser: 1,
                AstrologerID: AstrologerID,
                ExperiencedYears: AboutValue[0]?.ExperiencedYears || '',
                skills: AboutValue[0]?.skills || "",
                CategoryID: AboutValue[0]?.CategoryID || "",
                Languages: AboutValue[0]?.Languages || "",
                Aboutme: AboutValue[0]?.Aboutme || ""
                //  Aboutme: ""
            });
            setaboutusdata(AboutValue[0]?.Aboutme || "")
        }
    }, [AboutValue, AstrologerID]);


    const AboutUpdate = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';
        // Validation checks
        if (AboutValue.ExperiencedYears === "") {
            error = true;
            errorMsg = 'Please fill ExperiencedYears.';
        } else if (AboutValue.skills === "") {
            error = true;
            errorMsg = 'Please fill skills.';
        }
        else if (AboutValue.CategoryID === "") {
            error = true;
            errorMsg = 'Please fill CategoryID.';
        }
        else if (AboutValue.Languages === "") {
            error = true;
            errorMsg = 'Please fill Languages.';
        }
        if (!error) {
          
            const postdatas = { Aboutme: aboutusdata, AstrologerID: selectedAstroId, CategoryID: AboutValue.CategoryID, Languages: AboutValue.Languages, skills: AboutValue.skills, ExperiencedYears: AboutValue.ExperiencedYears }
          
            await AddUpdate('Astrologer/UpdateAstrologerAboutMe', postdatas);
            refereshfunction()
            onClose()
            swal('Good job!', 'Successfully Update', "success");
        } else {
            swal('Oops', errorMsg, "error");
        }
    }


    const SkillsChange = (e) => {
        const id = [];
        if (e) {
            e.forEach((item) => {
                id.push(item.value);
            });
            SetAboutValue({
                ...AboutValue,
                skills: id.toString()
            });
        } else {
            SetAboutValue({
                ...AboutValue,
                skills: ''
            });
        }
    };
    const CategoryChange = (e) => {
        const id = [];
        if (e) {
            e.forEach((item) => {
                id.push(item.value);
            });
            SetAboutValue({
                ...AboutValue,
                CategoryID: id.toString()
            });
        } else {
            SetAboutValue({
                ...AboutValue,
                CategoryID: ''
            });
        }
    };
    const LanguageChange = (e) => {
        const id = [];
        if (e) {
            e.forEach((item) => {
                id.push(item.value);
            });
            SetAboutValue({
                ...AboutValue,
                Languages: id.toString()
            });
        } else {
            SetAboutValue({
                ...AboutValue,
                Languages: ''
            });
        }
    };

   

    const customPostData = async (url, postdata) => {
        try {
            const response = await fetch(`${baseURLS}Gemini/ask`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(postdata),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
          
            setaboutusdata(data)
            return data;
        } catch (error) {
            console.error("Error while fetching:", error);
            return { success: false, data: null, Message: error.message };
        }
    };

    const Aboutusfunction = async () => {
        const postdata = { AstroId: selectedAstroId };
        const res = await customPostData("Gemini/ask", postdata);

      

        if (res?.success && typeof res?.data === "string") {

            const aboutMeMatch = res.data.match(/ABOUT_ME:\s*([\s\S]*?)(?=\n*\s*SERVICES:|$)/);

            if (aboutMeMatch) {
                const aboutMe = aboutMeMatch[1].trim();
               
                setaboutusdata(aboutMe);
            } else {
                console.warn("ABOUT_ME section not found — fallback using full data");
                setaboutusdata(res.data);
            }
        } else {
            console.warn("Invalid or missing data");
            setaboutusdata("");
        }
    };


    const checkDisplayExist = async (value) => {
        if (!value) {
            setDisplayError("");
            return;
        }

        try {
            setCheckingDisplay(true);

            const payload = {
                // AstrologerID: Value.AstrologerID || 0,
                DisplayName: value,
            };

            const res = await AddUpdate("Astrologer/AstrlogerCheckNameExist", payload);

            
            const parsed = JSON.parse(res?.data?.data || "{}");
            const exist = parsed?.Table?.[0]?.AstrologerExist;

            if (exist == 1) {
                setDisplayError("Display Name already exists");
            } else {
                setDisplayError("");
            }

        } catch (err) {
            console.log("Display check error", err);
        } finally {
            setCheckingDisplay(false);
        }
    };


    useEffect(() => {
        const timer = setTimeout(() => {
            checkDisplayExist(Value.DisplayName);
        }, 500);

        return () => clearTimeout(timer);
    }, [Value.DisplayName]);

    return (
        <Fragment>

            <div className="modal-header d-flex align-items-center justify-content-between p-3">
                <PageTitle className="m-0 p-0" activeMenu="Home" motherMenu="Astrologers" />

                {selectedAstroId ? (
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={onClose}
                    >
                        <i className="flaticon-delete-1"></i> Close
                    </button>
                ) : null}
            </div>



            <div className="row card_row g-0">
                <div className="col-xl-9 ">
                    <div className="#">
                        <div className="card-body">
                            <div className="profile-tab">
                                <div className="custom-tab-1">
                                    <Tab.Container defaultActiveKey='Posts'>
                                        <Nav as='ul' className="nav nav-tabs">
                                            <Nav.Item as='li' className="nav-item">
                                                <Nav.Link to="#my-posts" eventKey='Posts'>Basic Details</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as='li' i className="nav-item">
                                                <Nav.Link to="#about-me" eventKey='About' disabled={!selectedAstroId}>About Me</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as='li' className="nav-item">
                                                <Nav.Link to="#profile-Qualification" eventKey='Qualification' disabled={!selectedAstroId}>Qualification</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as='li' className="nav-item">
                                                <Nav.Link to="#profile-Bank" eventKey='Bank' disabled={!selectedAstroId}>Bank Details</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as='li' className="nav-item">
                                                <Nav.Link to="#profile-Attachment" eventKey='Attachment' disabled={!selectedAstroId}>Attachment</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as='li' className="nav-item">
                                                <Nav.Link to="#profile-Review" eventKey='Review' disabled={!selectedAstroId}>Review</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                        <Tab.Content>
                                            <Tab.Pane id="my-posts" eventKey='Posts'>
                                                <div className="pt-3">
                                                    <div className="settings-form">
                                                        <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                                                            <div className="row">
                                                                <div className="form-group mb-3 col-md-4">
                                                                    <label className="form-label" >First Name  <span className="text-danger star-error" >*</span></label>

                                                                    <input type="text" name="FirstName" placeholder="First Name"
                                                                        value={Value?.FirstName} onChange={handleChange}
                                                                    />
                                                                </div>
                                                                <div className="form-group mb-3 col-md-4">
                                                                    <label className="form-label">Last Name</label>

                                                                    <input type="text" name="LastName" placeholder="Last Name"
                                                                        value={Value?.LastName} onChange={handleChange}
                                                                    />
                                                                </div>
                                                                <div className="form-group mb-3 col-md-4">
                                                                    <label className="form-label">Display Name<span className="text-danger star-error" >*</span></label>

                                                                    <input type="text" name="DisplayName" placeholder="Display Name"
                                                                        value={Value?.DisplayName} onChange={handleChange}
                                                                    />
                                                                    {displayError && !selectedAstroId && (
                                                                        <small className="text-danger">{displayError}</small>
                                                                    )}

                                                                    {checkingDisplay && !selectedAstroId && (
                                                                        <small>Checking...</small>
                                                                    )} 
                                                                </div>
                                                                <div className="form-group mb-3 col-md-6">
                                                                    <label className="form-label" >Email</label>
                                                                    <input type="text" name="EmailID" placeholder="Enter Email"
                                                                        value={Value?.EmailID} onChange={handleChange}
                                                                    />
                                                                </div>
                                                                <div className="form-group mb-3 col-md-6">
                                                                    <label className="form-label">Reg Mobile No.<span className="text-danger star-error" >*</span></label>

                                                                    <input type="text" name="RegMobileNo" readOnly={!!selectedAstroId} maxLength={10} placeholder="Enter Reg No"
                                                                        value={Value?.RegMobileNo} onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row align-items-center">
                                                                <div className="form-group mb-3 col-md-6  ">
                                                                    <label className="form-label" >Date Of Birth</label>
                                                                    <div className="">
                                                                        <DatePicker
                                                                            id='DOB'
                                                                            name='DOB'
                                                                            // className="form-control  "
                                                                            dateFormat="MM/dd/yyyy"
                                                                            onChange={(date) => { setDOB(date); SetValue({ ...Value, ['DOB']: date ? getShowingMonthDateYear(date) : null }) }}
                                                                            selected={DOB}
                                                                            timeInputLabel
                                                                            maxDate={new Date()}
                                                                            isClearable={Value?.DOB ? true : false}
                                                                            placeholderText={Value?.DOB ? Value?.DOB : 'Select...'}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group mb-3 col-md-6">
                                                                    <label className="form-label">Time Of Birth</label>
                                                                    <input type="time" name="TOB" placeholder="Time Of Birth"
                                                                        value={Value?.TOB} onChange={handleTimeChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-3">
                                                                <label className="form-label">Place Of Birth<span className="text-danger star-error" >*</span></label>

                                                                <input type="text" name="POB" placeholder="Birth Address"
                                                                    value={Value?.POB} onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group mb-3">
                                                                <label className="form-label">Faith</label>
                                                                <input type="text" name="Faith" placeholder="Faith"
                                                                    value={Value?.Faith} onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="form-group mb-3">
                                                                <label className="form-label">Current Address<span className="text-danger star-error" >*</span></label>

                                                                <input type="text" name="CurrentAddress" placeholder="Address"
                                                                    value={Value?.CurrentAddress} onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div className="row">
                                                                <div className="form-group mb-3 col-md-6">
                                                                    <label className="form-label" >City<span className="text-danger star-error" >*</span></label>

                                                                    <input type="text" name="City"
                                                                        value={Value?.City} onChange={handleChange}
                                                                    />
                                                                </div>
                                                                <div className="form-group mb-3 col-md-6">
                                                                    <label className="form-label">Zip</label>
                                                                    <input type="text" name="PINCode" maxLength={6}
                                                                        value={Value?.PINCode} onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="form-group mb-3 col-md-6">
                                                                    <label className="form-label">PAN Card No</label>

                                                                    <input
                                                                        type="text"
                                                                        name="PANCardNo"
                                                                        style={{ textTransform: "uppercase" }}
                                                                        maxLength={10}
                                                                        value={Value?.PANCardNo}
                                                                        onChange={handleChange}
                                                                        placeholder="PAN Card No"

                                                                    />
                                                                </div>
                                                                <div className="form-group mb-3 col-md-6">
                                                                    <label className="form-label">Aadhar No<span className="text-danger star-error" >*</span></label>

                                                                    <input
                                                                        type="text"
                                                                        maxLength={12}
                                                                        name="AadharNo"
                                                                        value={Value?.AadharNo}
                                                                        onChange={handleChange}
                                                                        placeholder="Aadhar No"

                                                                    />
                                                                </div>




                                                                <div className="form-group mb-3 col-md-6">
                                                                    <label className="form-label">
                                                                        Marital Status<span className="text-danger star-error">*</span>
                                                                    </label>

                                                                    <div className="d-flex gap-4 mt-2">
                                                                        <label className="d-flex align-items-center gap-1">
                                                                            <input
                                                                                type="radio"
                                                                                name="Maritalstatus"
                                                                                value="Married"
                                                                                checked={Value?.Maritalstatus === "Married"}
                                                                                onChange={handleChange}
                                                                            />
                                                                            <span>Married</span>
                                                                        </label>

                                                                        <label className="d-flex align-items-center gap-1">
                                                                            <input
                                                                                type="radio"
                                                                                name="Maritalstatus"
                                                                                value="Unmarried"
                                                                                checked={Value?.Maritalstatus === "Unmarried"}
                                                                                onChange={handleChange}
                                                                            />
                                                                            <span>Unmarried</span>
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div className="form-group mb-3 col-md-6">
                                                                    <label className="form-label">
                                                                        Gender<span className="text-danger star-error">*</span>
                                                                    </label>

                                                                    <div className="d-flex gap-4 mt-2">
                                                                        <label className="d-flex align-items-center gap-1">
                                                                            <input
                                                                                type="radio"
                                                                                name="Gender"
                                                                                value="Male"
                                                                                checked={Value?.Gender === "Male"}
                                                                                onChange={handleChange}
                                                                            />
                                                                            <span>Male</span>
                                                                        </label>

                                                                        <label className="d-flex align-items-center gap-1">
                                                                            <input
                                                                                type="radio"
                                                                                name="Gender"
                                                                                value="Female"
                                                                                checked={Value?.Gender === "Female"}
                                                                                onChange={handleChange}
                                                                            />
                                                                            <span>Female</span>
                                                                        </label>
                                                                    </div>
                                                                </div>



                                                        


                                                                <div className="form-group mb-3 col-md-2">
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input m-0"
                                                                            style={{ width: "16px", height: "16px" }}
                                                                            name="IsHomePage"
                                                                            id="isHomePageCheckbox"
                                                                            onChange={HandleChange}
                                                                            checked={Value?.IsHomePage}
                                                                        />
                                                                        <label
                                                                            htmlFor="isHomePageCheckbox"
                                                                            className="form-check-label m-0"
                                                                            style={{ fontSize: "14px", lineHeight: "1" }}
                                                                        >
                                                                            Is_HomePage
                                                                        </label>
                                                                    </div>
                                                                </div>


                                                            </div>
                                                            {selectedAstroId ? (
                                                                <button className="btn btn-primary" type="submit" onClick={handleAddFormUpdate}>
                                                                    Update
                                                                </button>
                                                            ) : (
                                                                <button className="btn btn-primary" type="submit" onClick={handleAddFormSubmit}>
                                                                    Save
                                                                </button>
                                                            )}

                                                        </form>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane id="about-me" eventKey='About'>
                                              
                                                <div className="row">
                                                    <div className="col-lg-12 mt-2">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="comment" className="text-black font-w600">About Details</label>

                                                            <textarea
                                                                rows={12}
                                                                name="Aboutme"
                                                                placeholder="Aboutme"
                                                                value={aboutusdata || AboutValue?.Aboutme}
                                                                onChange={HandleChangeAbout}
                                                            />


                                                        </div>
                                                        <button className="btn btn-primary" type="submit"
                                                            onClick={Aboutusfunction}
                                                        > Create Aboutus</button>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-4">
                                                            <div className="form-group mb-3" style={{ marginTop: "8px" }}>
                                                                <label htmlFor="author" className="text-black font-w600">Experience <span className="text-danger star-error" >*</span> </label>
                                                                <input type="text" defaultValue="Experience" name="ExperiencedYears" placeholder="Experience"
                                                                    value={AboutValue?.ExperiencedYears} maxLength={2} onChange={HandleChangeAbout}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-8">
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="author" className="text-black font-w600">Language  <span className="text-danger star-error" >*</span></label>

                                                                <div className="col-12 col-md-12 col-lg-12 mt-2 dropdown__box">

                                                                    <Select
                                                                        name="Languages"
                                                                        isMulti
                                                                        isClearable
                                                                        value={LanguagesData.filter(language =>
                                                                            AboutValue?.Languages?.split(',').includes(language.value.toString())
                                                                        )}
                                                                        options={LanguagesData}
                                                                        onChange={LanguageChange}
                                                                        placeholder="Select languages"
                                                                    />

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="author" className="text-black font-w600">Skills   <span className="text-danger star-error" >*</span></label>
                                                            {/* <span className="text-danger star-error" >*</span> */}
                                                            <div className="col-12 col-md-12 col-lg-12 mt-2 dropdown__box">


                                                                <Select
                                                                    name="skills"
                                                                    isMulti
                                                                    isClearable
                                                                    value={SkillsData.filter(skill =>
                                                                        AboutValue?.skills?.split(',').includes(skill.value.toString())
                                                                    )}
                                                                    options={SkillsData}
                                                                    onChange={SkillsChange}
                                                                    placeholder="Select Skills"
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="author" className="text-black font-w600">Category   <span className="text-danger star-error" >*</span> </label>

                                                            <div className="col-12 col-md-12 col-lg-12 mt-2 dropdown__box">


                                                                <Select
                                                                    name="CategoryID"
                                                                    isMulti
                                                                    isClearable
                                                                    value={CategroyData.filter(skill =>
                                                                        AboutValue?.CategoryID?.split(',').includes(skill.value.toString())
                                                                    )}
                                                                    options={CategroyData}
                                                                    onChange={CategoryChange}
                                                                    placeholder="Select Categorys"
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12">
                                                        <div className="form-group mb-3">
                                                            <button className="btn btn-primary" type="submit" onClick={AboutUpdate}> Update</button> </div>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane id="profile-Qualification" eventKey='Qualification'>
                                                <div className="pt-3">
                                                    <div className="settings-form">
                                                        <form onSubmit={(e) => e.preventDefault()}>
                                                            
                                                            <div className="row">
                                                                <div className="form-group mb-3">
                                                                    <label className="form-label">Select Your Highest Qualification</label>
                                                                    <span className="text-danger star-error">*</span>
                                                                    <Select
                                                                        name="HighestQualification"
                                                                        value={
                                                                            QualificationDrpData.find(
                                                                                (obj) => obj.value?.toString() === QualificationValue?.HighestQualification?.toString()
                                                                            ) || null
                                                                        }
                                                                        options={QualificationDrpData}
                                                                        onChange={(e) => ChangeDropDown(e, 'HighestQualification')}
                                                                        placeholder="Select Highest Qualification"
                                                                        isClearable
                                                                    />

                                                                </div>

                                                                <div className="form-group mb-3">
                                                                    <label className="form-label">Select Your Degree/Diploma</label>
                                                                    <span className="text-danger star-error">*</span>
                                                                    <Select
                                                                        name="DregeeDiploma"
                                                                        value={
                                                                            DregeeDiplomaDrpData.find(
                                                                                (obj) => obj.value?.toString() === QualificationValue?.DregeeDiploma?.toString()
                                                                            ) || null
                                                                        }
                                                                        options={DregeeDiplomaDrpData}
                                                                        onChange={(e) => ChangeDropDown(e, 'DregeeDiploma')}
                                                                        placeholder="Select Degree/Diploma"
                                                                        isClearable
                                                                    />

                                                                </div>

                                                                <div className="form-group mb-3">
                                                                    <label className="form-label">College/School/University</label>
                                                                    <span className="text-danger star-error">*</span>
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Enter College/University"
                                                                        name="CollegeUniversity"

                                                                        value={QualificationValue?.CollegeUniversity || ''}
                                                                        onChange={HandleChangeQualification}
                                                                    />
                                                                </div>

                                                                <div className="form-group mb-3">
                                                                    <label className="form-label">From where did you learn Astrology</label>
                                                                    <textarea

                                                                        name="WhereLearnAstrology"
                                                                        rows={3}
                                                                        value={QualificationValue?.WhereLearnAstrology || ''}
                                                                        onChange={HandleChangeQualification}
                                                                    />
                                                                </div>
                                                            </div>


                                                            <button className="btn btn-primary" type="submit" onClick={UpdateQualification}>Update</button>
                                                        </form>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane id="profile-Bank" eventKey='Bank'>
                                                <BankDetails {...{ selectedAstroId }} />
                                            </Tab.Pane>
                                            <Tab.Pane id="profile-Attachment" eventKey='Attachment'>
                                                <div className="pt-3">
                                                    <div className="settings-form">
                                                        <form onSubmit={updateAttachment}>
                                                            <div className="post-input">
                                                                <label htmlFor="frontImg" className="text-black font-w600">Front Img</label>
                                                                <div className="input-group custom_file_input mb-3">
                                                                    <span className="input-group-text">Upload</span>
                                                                    <div className="form-file">
                                                                        <input
                                                                            type="file"
                                                                            name="frontImg"
                                                                            onChange={handleChangeAttichement}
                                                                            className="form-file-input form-control"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                
                                                                <input
                                                                    type="text"
                                                                    name="AadharFrontImgUrl"
                                                                    className={`form-control bg-transparent no-box-style`}
                                                                    placeholder="Please Attach Your Documents...."
                                                                    value={formDataAt?.Aadhar_front_img ? formDataAt.Aadhar_front_img.split('\\').pop() : ''}
                                                                    readOnly
                                                                />
                                                                <label htmlFor="backImg" className="text-black font-w600">Back Img</label>
                                                                <div className="input-group custom_file_input mb-3">
                                                                    <span className="input-group-text">Upload</span>
                                                                    <div className="form-file">
                                                                        <input
                                                                            type="file"
                                                                            name="backImg"
                                                                            onChange={handleChangeAttichement}
                                                                            className="form-file-input form-control"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                
                                                                <input
                                                                    type="text"
                                                                    name="AadharBackImgUrl"
                                                                    className={`form-control bg-transparent no-box-style`}
                                                                    placeholder="Please Attach Your Documents...."
                                                                    value={formDataAt?.Aadhar_back_img ? formDataAt.Aadhar_back_img.split('\\').pop() : ''} // 
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <button className="btn btn-primary" type="submit">Update</button>
                                                        </form>

                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane id="profile-Review" eventKey='Review'>
                                                <div className="col-xl-4">
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="card">
                                                                <div className="card-body">
                                                                    <div className="profile-statistics">
                                                                        <div className="text-center">
                                                                            <div className="row">
                                                                                <div className="col">
                                                                                    <h3 className="m-b-0">150</h3><span>Follower</span>
                                                                                </div>
                                                                                <div className="col">
                                                                                    <h3 className="m-b-0">140</h3> <span>Place Stay</span>
                                                                                </div>
                                                                                <div className="col">
                                                                                    <h3 className="m-b-0">45</h3> <span>Reviews</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="mt-4">
                                                                                <Link to="#" className="btn btn-primary mb-1 me-1">Follow</Link>
                                                                                <Button as="a" href="#" className="btn btn-primary mb-1 ms-1" onClick={() => dispatch({ type: 'sendMessage' })}>Send Message</Button>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xl-3 order_1 justify-content-center d-flex  align-items-start" style={{ marginTop: '38px' }}>
                    <div className="profile-info">
                        <div className="profile-photo">
                            <div className="image-placeholder">
                                <div className="avatar-edit">
                                    <input type="file" onChange={fileHandler} id="imageUpload" disabled={!selectedAstroId} onClick={(event) => event.target.value = null} style={{ display: 'none' }} />
                                    <label htmlFor="imageUpload" style={{ cursor: !selectedAstroId ? 'not-allowed' : 'pointer', opacity: !selectedAstroId ? 0.6 : 1, }} > </label>
                                </div>
                                <div className="avatar-preview">
                                    <div id="imagePreview">
                                        {/* <img id="saveImageFile" src={file ? URL.createObjectURL(file) : (Value.AvatarUrl ? `https://${Value.AvatarUrl.replace(/\\/g, "/")}` : user)} alt={file ? file.name : 'User Avatar'}
                                            style={{ cursor: !selectedAstroId ? 'not-allowed' : 'pointer', opacity: !selectedAstroId ? 0.6 : 1, }} /> */}
                                        <img
                                            id="saveImageFile"
                                            src={
                                                file
                                                    ? URL.createObjectURL(file)
                                                    : Value.AvatarUrl
                                                        ? `https://${Value.AvatarUrl.replace(/\\/g, "/")}`
                                                        : selectedAstroId
                                                            ? user
                                                            : profile_icon
                                            }
                                            alt={file?.name || "User Avatar"}
                                            // style={{                                //Old
                                            //     cursor: selectedAstroId ? "pointer" : "not-allowed",
                                            //     opacity: selectedAstroId ? 1 : 0.6,
                                            //     width: file || Value.AvatarUrl || selectedAstroId ? "auto" : "120px",
                                            //     height: file || Value.AvatarUrl || selectedAstroId ? "auto" : "120px",
                                            //     display: file || Value.AvatarUrl || selectedAstroId ? "block" : "flex",
                                            //     justifyContent: file || Value.AvatarUrl || selectedAstroId ? "unset" : "center",
                                            //     alignItems: file || Value.AvatarUrl || selectedAstroId ? "unset" : "center",
                                            //     marginLeft: file || Value.AvatarUrl || selectedAstroId ? "center" : "10px",
                                            //     objectFit:"contain",
                                            // }}
                                            style={{          //New
                                                cursor: selectedAstroId ? "pointer" : "not-allowed",
                                                opacity: selectedAstroId ? 1 : 0.6,
                                                width: "120px",
                                                height: "120px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginLeft: "10px",
                                                objectFit: "contain",
                                                borderRadius: "8px",
                                                backgroundColor: "#f5f5f5"
                                            }}


                                        />

                                    </div>


                                </div>
                                <button onClick={handleUpdatePhoto} disabled={!file || !selectedAstroId} className=" btn btn-primary text-white p-1" style={{ marginLeft: "30px" }}>
                                    Upload Photo
                                </button>
                            </div>
                        </div>
                        
                    </div>
                </div>

            </div>
        </Fragment >
    );
};

export default AstrologerAdd;



export const changeArrayFormat = (data, type) => {
    if (type === 'zip') {
        const result = data?.map((sponsor) =>
            ({ value: sponsor.zipId, label: sponsor.Zipcode })
        )
        return result
    }
    if (type === 'state') {
        const result = data?.map((sponsor) =>
            ({ value: sponsor.StateID, label: sponsor.StateName })
        )
        return result
    }
    if (type === 'city') {
        const result = data?.map((sponsor) =>
            ({ value: sponsor.CityID, label: sponsor.CityName })
        );
        return result
    } else {
        const result = data?.map((sponsor) =>
            ({ value: sponsor.AgencyID, label: sponsor.Agency_Name })
        )
        return result
    }

}